// extracted by mini-css-extract-plugin
module.exports = {"textBadgeComponent":"TextBadge_textBadgeComponent__1CXHf","gray":"TextBadge_gray__1P1QT"};